import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
// import '../App.css'; // Using App.css for now, might create HomePage.css later
import './HomePage.css'; // Import HomePage specific styles

function HomePage() {
  const navigate = useNavigate(); // Initialize navigate hook
  const { isLoggedIn } = useAuth(); // Get isLoggedIn from AuthContext

  const handleBuyClick = (e) => {
    if (!isLoggedIn) {
      e.preventDefault(); // Prevent default link navigation
      navigate('/auth'); // Navigate to login/registration page
    }
    // If logged in, allow the default link navigation to /purchase
  };

  return (
    <div className="homepage">
      {/* Top section - already handled by navigation in App.js */}

      {/* Main Content Area */}
      <section className="hero-section">
        <div className="container">
          <h1 className="product-title">螞蟻電視</h1>
          {/* TODO: Add slogan or brief description */}

          <div className="product-features">
            {/* Placeholder for feature images/icons */}
            <div className="feature-item">
              {/* <img src="..." alt="屏幕播放" /> */}
              <p>支持安卓設備</p>
            </div>
            <div className="feature-item">
              {/* <img src="..." alt="多语播放" /> */}
              <p>全球電視直播</p>
            </div>
            <div className="feature-item">
              {/* <img src="..." alt="多语播放" /> */}
              <p>追劇點播</p>
            </div>
             <div className="feature-item">
              {/* <img src="..." alt="稳定流畅" /> */}
              <p>稳定流畅</p>
            </div>
            {/* Add more feature items as needed */}
          </div>

          <Link to="/purchase" className="buy-button" onClick={handleBuyClick}>立即購買</Link>
        </div>
      </section>

      {/* Footer section - TODO: Implement a proper Footer component */}
      <footer className="site-footer">
        <div className="container">
          <p>© 2025 tvAnt Software. All rights reserved.</p>
          {/* TODO: Add other footer links/info */}
        </div>
      </footer>
    </div>
  );
}

export default HomePage; 